const initialState = {
	tags: [],
	tagCount: 0,
	followTags: [],
	followTagCount: 0,
	searchTags: [],
	searchTagCount: 0
}

const tag = (state = initialState, action) => {
	
	switch (action.type) {
		case 'GET_TAGS':
			return {
				...state,
				tags: action.tags,
				tagCount: action.count
			}

		case 'GET_SEARCH_TAGS':
			return {
				...state,
				searchTags: action.searchTags,
				searchTagCount: action.searchTagCount
			}

		case 'GET_FOLLOW_TAGS':
			return {
				...state,
				followTags: action.followTags,
				followTagCount: action.followTagCount
			}
		
			

		case 'RESET_TAG_STATE':
			return {
				...initialState
			}

		default:
			return { ...state }
	}
}

export default tag
